import { ApplicationConstants } from "./application";
import { ComponentCypressConstants } from "./components";
import { FeatureCypressConstants } from "./features";

export const CypressConstants = {
  application: ApplicationConstants,
  features: FeatureCypressConstants,
  components: ComponentCypressConstants
};
